import React from 'react';
interface WebinarModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const WebinarModal: React.FC<WebinarModalProps> = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4" onClick={onClose} data-id="element-521">
      <div className="bg-white rounded-3xl overflow-hidden max-w-md w-full" onClick={e => e.stopPropagation()} data-id="element-522">
        <div className="p-4 flex justify-end" data-id="element-523">
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 focus:outline-none" data-id="element-524">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-525">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-526" />
            </svg>
          </button>
        </div>
        <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }} data-id="element-527">
          <iframe src="https://app.webinargeek.com/embed/5e7c8763-630c-465a-9315-12067b2aa215?cst=mcc-gpm-adv1" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
          border: '1px solid #ccc',
          borderRadius: '25px'
        }} data-id="element-528" />
        </div>
        <div className="tve_iframe_cover" data-id="element-529"></div>
      </div>
    </div>;
};